var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page message-command-page" }, [
    _c("div", { staticClass: "saas-hero card-saas message-command-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("message.message")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(_vm._s(_vm.trans("message.compose"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "message-command-hero__subtitle" }, [
          _vm._v(
            _vm._s(_vm.trans("message.message")) +
              " · " +
              _vm._s(_vm.trans("message.compose"))
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "card-saas card-saas--flush saas-message-layout message-command-layout",
      },
      [
        _c(
          "div",
          { staticClass: "row g-0" },
          [
            _c("message-sidebar", {
              attrs: { menu: "compose", statistics: _vm.statistics },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col saas-message-main" },
              [_c("message-form")],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }